import { render, staticRenderFns } from "./ClientVetContactSection.vue?vue&type=template&id=09174a18"
import script from "./ClientVetContactSection.vue?vue&type=script&lang=js"
export * from "./ClientVetContactSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports